<script setup>
import FuzzySearch from 'fuzzy-search'
import { openDialogById, chunkArray } from '@/helpers'
// import Leaflet from '@components/LeafletMap.vue'
import { Head, Link, router, usePage } from '@inertiajs/vue3'
import { isClient } from '@/helpers'
// import ChartToggleBtn from '@components/ChartToggleBtn.vue'

// import { vIntersectionObserver } from '@vueuse/components'
// import { useIntersectionObserver } from '@vueuse/core'
// import { vInfiniteScroll } from '@vueuse/components'

const leaflet = defineAsyncComponent(() => import('@components/LeafletMap.vue'))

const props = defineProps({
	results: {
		type: Array,
		default: () => [],
	},
	searched: {
		type: [Array, Object],
		default: () => [],
	},
	visibleRankLimit: {
		type: Number,
		default: null,
	},
})

const page = usePage()

const isMounted = ref(false)
// const filtersChanged = ref(false)
const itemRefs = ref([])

// watch(
// 	() => wizardStore.totalFiltersCount,
// 	(newVal, oldVal) => {
// 		console.log('filters count changed')
// 		filtersChanged.value = true
// 	}
// )

const filtersDialog = defineAsyncComponent(() => import('@components/FiltersDialog.vue'))
const customBadge = defineAsyncComponent(() => import('@/Frontend/Components/CustomBadge.vue'))

const appStore = useAppStore()
const wizardStore = useWizardStore()
const chartView = ref(false)

// Set filters corresponding to url in case of manual setting the URL

wizardStore.$reset()
props.searched.locations.map(location => (wizardStore.locations[location.id] = location))
props.searched.food.map(f => wizardStore.foodProperties.push(Number(f)))
props.searched.how.map(h => wizardStore.howProperties.push(Number(h)))
props.searched.valuation.map(c => wizardStore.valuationProperties.push(c))
props.searched.partnerships.map(c => wizardStore.partnershipProperties.push(Number(c)))

if (isClient) {
	Array.from(new URL(window.location.href).searchParams).map(([key, value]) => {
		// Remove array index from key
		key = key.replace(/\d/, '')

		// console.log(`${key}=${value}`)
		wizardStore.pickedOrder.push(`${key}=${value}`)
	})
}

const isRankingsPage = computed(() => route().current() === 'ranking')

const filterTerm = ref('')
const searcher = new FuzzySearch(props.results, ['name', 'city'], {
	caseSensitive: false,
})

const searchLength = computed(() => {
	if (!filterTerm.value) return
	return searcher.search(filterTerm.value).length
})

const filteredSearch = computed(() => {
	if (!filterTerm.value) return chunkArray(props.results, 10)
	// console.log(chunkArray(searcher.search(filterTerm.value), 10))
	// Not working properly
	// console.log(searcher.search(filterTerm.value))
	return chunkArray(searcher.search(filterTerm.value), 10)
})

// const filteredSearch = computed(() => {
// 	if (!filterTerm.value) return props.results

// 	return searcher.search(filterTerm.value)
// })

const mapData = computed(() => {
	if (!props.results.length) return []
	return props.results.map(res => {
		return {
			id: res.id,
			name: res.name,
			coords: [res.latitude, res.longitude],
			popup: !res.description
				? false
				: `<h5 class="ff-serif">${res.name}</h5>
                ${res.description}
            `,
		}
	})
})

// add selection class when marker is clicked
const selectedOnMap = ref(false)
const scrollIntoView = id => {
	// first remove previous selection
	const prev = document.querySelector('.selected')
	if (prev) prev.classList.remove('selected')

	const selected = document.querySelector(`#${id}`)
	if (selected) {
		selected.classList.add('selected')
		selected.scrollIntoView({
			block: 'center',
			behavior: 'smooth',
		})

		// remove
		setTimeout(() => {
			selected.classList.remove('selected')
		}, 2000)
	}
}

const visibles = ref(new Set([0]))

// function onIntersectionObserverTwo([{ isIntersecting, target }]) {
// 	// console.log(target)
// 	if (isIntersecting) {
// 		// console.log(true)
// 		visibles.value.add(Number(target.dataset.chunk))
// 	} else {
// 		visibles.value.delete(Number(target.dataset.chunk))
// 		// console.log(false)
// 	}
// }

// const wrapper = ref(null)

onMounted(() => {
	isMounted.value = true

	const observer = new IntersectionObserver(
		function (entries, observer) {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					visibles.value.add(Number(entry.target.dataset.chunk))
				} else {
					visibles.value.delete(Number(entry.target.dataset.chunk))
				}
			})
		},
		{
			//rootMargin: '0px 50% 50% 0px',
		}
	)
	itemRefs.value.forEach(section => {
		observer.observe(section)
	})

	// const results = document.querySelectorAll('.result')

	// console.log(itemRefs.value[0])

	// useIntersectionObserver(results, ([{ isIntersecting }], observerElement) => {
	// 	// targetIsVisible.value = isIntersecting

	// 	if (isIntersecting) {
	// 		console.log('popke')
	// 		// visibles.value.add(Number(observerElement.dataset.resultId))
	// 	} else {
	// 		// visibles.value.delete(Number(observerElement.dataset.resultId))
	// 	}
	// })
})

// function onIntersectionObserver([{ isIntersecting, target }]) {
// 	if (isIntersecting) {
// 		// console.log(target)
// 		visibles.value.add(Number(target.dataset.resultId))
// 	} else {
// 		visibles.value.delete(Number(target.dataset.resultId))
// 	}
// }

const leafletRef = ref(null)
// const preventIntersections = ref(false)

function flyTo(coords, zoom, id, options) {
	const map = leafletRef.value
	if (!map) return
	map.flyTo(coords, zoom, id, options)
}

function scrollToTop() {
	window.scrollTo(0, 0)
}

// Add SEO
const pageMeta = [
	{ tag: 'link', tagItem: 'rel', tagValue: 'canonical', contentItem: 'href', contentValue: `https://lekker.nl${isRankingsPage ? '/restaurant/klassering' : '/results'}` },
	{ tag: 'meta', tagItem: 'name', tagValue: 'title', contentItem: 'content', contentValue: `Lekker` },
	{ tag: 'meta', tagItem: 'name', tagValue: 'description', contentItem: 'content', contentValue: `De restaurantgids van Nederland` },
	{ tag: 'meta', tagItem: 'property', tagValue: 'og:title', contentItem: 'content', contentValue: `${isRankingsPage ? 'Top-500' : 'Zoekresultaten'} - Lekker` },
	{ tag: 'meta', tagItem: 'property', tagValue: 'og:description', contentItem: 'content', contentValue: `De restaurantgids van Nederland` },
	{ tag: 'meta', tagItem: 'property', tagValue: 'og:url', contentItem: 'content', contentValue: `https://lekker.nl${isRankingsPage ? '/restaurant/klassering' : '/results'}` },
	{ tag: 'meta', tagItem: 'name', tagValue: 'twitter:card', contentItem: 'content', contentValue: 'summary' },
	{ tag: 'meta', tagItem: 'name', tagValue: 'twitter:site', contentItem: 'content', contentValue: '@lekker500' },
]
</script>

<template>
	<Head>
		<title>{{ isRankingsPage ? 'Top-500' : $t('Searchresults') }}</title>
		<component
			:is="`${meta.tag}`"
			v-for="(meta, metaIndex) in pageMeta"
			:key="`pagemeta-${metaIndex}`"
			:[meta.tagItem]="meta.tagValue"
			:[meta.contentItem]="meta.contentValue"
		/>
	</Head>

	<button
		class="btn btn-chart-toggle fw-bold d-flex gap-2 d-md-none"
		style="position: fixed; left: 50%; transform: translateX(-50%); bottom: 25px; z-index: 3000"
		@click="chartView = !chartView"
	>
		<i :class="[chartView ? 'str-menu' : 'str-maps']" />
		{{ chartView ? $t('maps.list') : $t('maps.map') }}
	</button>

	<main
		class="results-layout-1"
		:style="{
			minHeight: `calc(100vh - ${!appStore.isDesktop ? '55px' : '65px'})`,
		}"
	>
		<div class="results-container">
			<div
				v-if="!isRankingsPage"
				id="filter-input"
				class="filter-input position-sticky bg-white bg-md-body py-3 mb-3 mb-lg-0"
			>
				<div class="d-flex px-4 pe-xl-4 gap-2">
					<input
						v-model="filterTerm"
						type="text"
						class="form-control icon-left icon-search bg-white shadow-sm"
						:placeholder="$t('Search by location or restaurant')"
						:readonly="!results.length"
						@keyup.escape="filterTerm = ''"
					/>
					<button
						class="btn btn-white border-neutral-900 px-4 fw-bold fs-6 shadow-sm"
						@click="openDialogById('filters-dialog')"
					>
						<span class="d-flex align-items-center gap-1">
							<span>{{ $t('Filters') }}</span>
							<custom-badge
								v-if="wizardStore.totalFiltersCount"
								:size="20"
								class="text-bg-accent-500 fs-7"
							>
								{{ wizardStore.totalFiltersCount }}
							</custom-badge>
						</span>
					</button>
				</div>
			</div>

			<div
				class="container-fluid px-4 pe-xl-4"
				:class="[isRankingsPage ? 'mt-3' : null]"
			>
				<div class="row mb-1">
					<div
						v-if="!isRankingsPage"
						class="col-12"
					>
						<h5 v-if="filterTerm">{{ $t(':count of :total Restaurants', { count: searchLength, total: results.length }) }}</h5>
						<h5 v-else>{{ $t(':total Restaurants', { total: results.length }) }}</h5>
						<div
							v-if="!results.length"
							class="bg-white rounded p-4"
						>
							<h4>{{ $t('Unfortunately, no results') }}</h4>
							<p class="mb-4">{{ $t("We couldn't find a match based on your search filters. Adjust your filters to find restaurants.") }}</p>
							<div class="d-flex justify-content-between align-items-center">
								<span>
									<span class="h5 fw-bolder">{{ $t('Chosen filters') }}</span>
									<custom-badge
										v-if="wizardStore.totalFiltersCount"
										:size="20"
										class="ms-1 text-bg-accent-500 fs-7"
									>
										{{ wizardStore.totalFiltersCount }}
									</custom-badge>
								</span>
								<span
									v-if="wizardStore.totalFiltersCount"
									class="feature-link cursor-pointer fs-7"
									@click="openDialogById('filters-dialog')"
								>
									{{ $t('Adjust') }}
									<i class="str-arrow-right" />
								</span>
							</div>
						</div>
					</div>

					<div
						v-if="isRankingsPage"
						class="col-12"
					>
						<div
							v-if="visibleRankLimit !== null"
							class="rounded bg-white p-3 shadow-sm mb-3"
						>
							<p><i class="str-info-fill me-1" /> <b>Let op!</b> Alleen de eerste {{ visibleRankLimit }} restaurants worden getoond. Vanaf daar worden restaurants op alfabetische volgorde getoond.</p>
							<p class="fw-bold">Meer zien? Bestel dan nu de gids</p>
							<Link
								class="btn btn-theme-500 fw-bold w-100"
								:href="route('order')"
								target="_blank"
							>
								Bestel nu
								<i class="str-arrow-right ms-1" />
							</Link>
						</div>
						<div
							v-else
							class="rounded bg-white p-3 shadow-sm mb-3"
						>
							<p class="mb-0"><i class="str-info-fill me-1" /> <b>Let op!</b> De ranking gaat van 1 t/m 100. Vanaf daar worden restaurants op alfabetische volgorde getoond.</p>
						</div>
						<h5>Top 500 restaurants</h5>
					</div>
				</div>

				<div
					v-for="(chunk, chunkIndex) in filteredSearch"
					:id="`chunk-${chunkIndex}`"
					:key="`chunk-${chunkIndex}`"
					:ref="el => itemRefs.push(el)"
					:data-chunk="chunkIndex"
					class="row g-4 mb-4"
				>
					<div
						v-for="result in chunk"
						:id="`result-${result.id}`"
						:key="`res-${result.id}`"
						class="col-sm-6 col-md-12 col-xl-6"
						style="min-height: 345px; scroll-behavior: smooth"
						:aria-label="result.name"
					>
						<theme-card-restaurant-result
							v-if="isMounted && visibles.has(chunkIndex)"
							:item="result"
							:selected-on-map="selectedOnMap === result.id"
							class="h-100 shadow-sm"
							@theme-marker-button="
								() => {
									// if (selectedOnMap === result.id) return

									selectedOnMap = result.id
									chartView = true
									flyTo([result.latitude, result.longitude], 18, result.id, { animate: true, duration: 1 })
								}
							"
						/>
					</div>
				</div>
			</div>
		</div>

		<client-only>
			<leaflet
				ref="leafletRef"
				:pinpoint-current="true"
				:data="mapData"
				:initial-zoom="results.length === 1 ? 18 : false"
				tooltips
				@reset="scrollToTop()"
				@marker-click="
					val => {
						chartView = false
						flyTo(val.coords, true, val.id)
						scrollIntoView(`result-${val.id}`)
						selectedOnMap = val.id
					}
				"
			>
				<template #map="{ leafletId }">
					<div
						:id="leafletId"
						style="--aspect-ratio: null"
						:style="{
							height: `calc(100vh - ${appStore.getWindowWidth <= appStore.breakpoints.lg ? '55px' : '65px'})`,
							top: appStore.getWindowWidth <= appStore.breakpoints.lg ? '55px' : '65px',
						}"
						:visible="(chartView && appStore.getWindowWidth <= appStore.breakpoints.lg) ?? null"
					></div>
				</template>
			</leaflet>
		</client-only>
	</main>

	<filters-dialog />
	<!-- <teleport to="body">
	</teleport> -->
</template>
